export function init() {
    let slider = $('.slider').lightSlider({ item: 1, enableTouch: true });
    $(document).on('open.zf.reveal', function (e) {
        if (slider !== undefined && slider.length > 0) {
            const imageId = $(e.target).data('image-id') ?? 0;
            slider.refresh();
            slider.goToSlide(imageId);
        }
    });
    $(document).on('click', 'img[data-open="modal-images"]', function() {
        const imageId = $(this).data('image-id');
        $('#modal-images').data('image-id', imageId);
    });
}
